export const SCENE_ANIMATION_5 = {
    "items": [
        {
            "time": 0.019999999552965165,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.001,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.029999999329447748,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.001,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.03999999910593033,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.001,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.05999999865889549,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.003,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.0729999989271164,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.005,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.07699999958276749,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.008,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.09000000357627869,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.009,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.10400000214576721,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.012,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.11800000071525574,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.016,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.13300000131130219,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.021,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.1469999998807907,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.026,0.000,1.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.16099999845027924,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.032,0.000,0.999",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.17399999499320985,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.037,0.000,0.999",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.1850000023841858,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.043,0.000,0.999",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.19900000095367433,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.049,0.000,0.999",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.21299999952316285,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.056,0.000,0.998",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.22699999809265138,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.064,0.000,0.998",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.23999999463558198,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.071,0.000,0.997",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.2549999952316284,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.079,0.000,0.997",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.27000001072883608,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.089,0.000,0.996",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.27900001406669619,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.099,0.000,0.995",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.29100000858306887,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.105,0.000,0.994",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.3059999942779541,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.114,0.000,0.994",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.32100000977516177,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.124,0.000,0.992",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.3330000042915344,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.136,0.000,0.991",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.3479999899864197,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.145,0.000,0.989",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.3610000014305115,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.156,0.000,0.988",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.37299999594688418,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.167,0.000,0.986",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.3880000114440918,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.177,0.000,0.984",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.4000000059604645,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.189,0.000,0.982",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.41200000047683718,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.199,0.000,0.980",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.42500001192092898,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.210,0.000,0.978",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.44200000166893008,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.222,0.000,0.975",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.453000009059906,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.237,0.000,0.972",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.46700000762939455,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.247,0.000,0.969",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.48399999737739565,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.260,0.000,0.966",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.49799999594688418,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.276,0.000,0.961",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.5049999952316284,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.288,0.000,0.958",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.5189999938011169,
            "data": [
                "prisoner,4.405,0.000,1.937,0.000,0.295,0.000,0.955",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.082,0.273,1.560,0.001,-0.992,0.046,0.119"
            ]
        },
        {
            "time": 0.5329999923706055,
            "data": [
                "prisoner,4.406,0.000,1.937,0.000,0.309,0.000,0.951",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.084,0.273,1.559,0.002,-0.991,0.046,0.123"
            ]
        },
        {
            "time": 0.5490000247955322,
            "data": [
                "prisoner,4.408,0.000,1.937,0.000,0.321,0.000,0.947",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.088,0.273,1.558,0.002,-0.990,0.045,0.130"
            ]
        },
        {
            "time": 0.5609999895095825,
            "data": [
                "prisoner,4.411,0.000,1.937,0.000,0.337,0.000,0.942",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.094,0.273,1.557,0.002,-0.989,0.045,0.144"
            ]
        },
        {
            "time": 0.5759999752044678,
            "data": [
                "prisoner,4.414,0.000,1.937,0.000,0.348,0.000,0.937",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.101,0.273,1.555,0.003,-0.987,0.045,0.157"
            ]
        },
        {
            "time": 0.5889999866485596,
            "data": [
                "prisoner,4.419,0.000,1.937,0.000,0.362,0.000,0.932",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.110,0.274,1.553,0.004,-0.983,0.044,0.176"
            ]
        },
        {
            "time": 0.6019999980926514,
            "data": [
                "prisoner,4.424,0.000,1.937,0.000,0.375,0.000,0.927",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.120,0.274,1.550,0.005,-0.980,0.044,0.195"
            ]
        },
        {
            "time": 0.6150000095367432,
            "data": [
                "prisoner,4.430,0.000,1.937,0.000,0.387,0.000,0.922",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.131,0.274,1.547,0.005,-0.975,0.043,0.217"
            ]
        },
        {
            "time": 0.628000020980835,
            "data": [
                "prisoner,4.437,0.000,1.937,0.000,0.400,0.000,0.917",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.274,1.544,0.006,-0.969,0.042,0.242"
            ]
        },
        {
            "time": 0.6439999938011169,
            "data": [
                "prisoner,4.444,0.000,1.937,0.000,0.412,0.000,0.911",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.156,0.275,1.541,0.007,-0.963,0.041,0.267"
            ]
        },
        {
            "time": 0.6589999794960022,
            "data": [
                "prisoner,4.453,0.000,1.937,0.000,0.427,0.000,0.904",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.174,0.275,1.536,0.008,-0.953,0.040,0.301"
            ]
        },
        {
            "time": 0.6729999780654907,
            "data": [
                "prisoner,4.463,0.000,1.937,0.000,0.441,0.000,0.897",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.191,0.276,1.532,0.009,-0.941,0.039,0.335"
            ]
        },
        {
            "time": 0.6869999766349793,
            "data": [
                "prisoner,4.472,0.000,1.937,0.000,0.454,0.000,0.891",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.208,0.276,1.527,0.011,-0.929,0.038,0.367"
            ]
        },
        {
            "time": 0.7020000219345093,
            "data": [
                "prisoner,4.482,0.000,1.937,0.000,0.468,0.000,0.884",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.226,0.276,1.523,0.012,-0.916,0.036,0.400"
            ]
        },
        {
            "time": 0.7170000076293945,
            "data": [
                "prisoner,4.493,0.000,1.937,0.000,0.482,0.000,0.876",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.246,0.277,1.518,0.013,-0.898,0.035,0.437"
            ]
        },
        {
            "time": 0.734000027179718,
            "data": [
                "prisoner,4.505,0.000,1.937,0.000,0.495,0.000,0.869",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.266,0.277,1.513,0.013,-0.880,0.034,0.474"
            ]
        },
        {
            "time": 0.75,
            "data": [
                "prisoner,4.518,0.000,1.937,0.000,0.510,0.000,0.860",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.289,0.278,1.507,0.014,-0.858,0.032,0.513"
            ]
        },
        {
            "time": 0.7670000195503235,
            "data": [
                "prisoner,4.532,0.000,1.937,0.000,0.524,0.000,0.852",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.311,0.278,1.501,0.015,-0.834,0.030,0.551"
            ]
        },
        {
            "time": 0.7850000262260437,
            "data": [
                "prisoner,4.547,0.000,1.937,0.000,0.540,0.000,0.842",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.335,0.279,1.495,0.016,-0.806,0.028,0.592"
            ]
        },
        {
            "time": 0.8029999732971191,
            "data": [
                "prisoner,4.562,0.000,1.937,0.000,0.554,0.000,0.832",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.359,0.279,1.489,0.016,-0.776,0.027,0.630"
            ]
        },
        {
            "time": 0.8190000057220459,
            "data": [
                "prisoner,4.578,0.000,1.937,0.000,0.569,0.000,0.822",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.383,0.280,1.483,0.017,-0.744,0.025,0.667"
            ]
        },
        {
            "time": 0.8360000252723694,
            "data": [
                "prisoner,4.593,0.000,1.937,0.000,0.583,0.000,0.812",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.404,0.280,1.477,0.017,-0.714,0.023,0.699"
            ]
        },
        {
            "time": 0.8500000238418579,
            "data": [
                "prisoner,4.608,0.000,1.937,0.000,0.596,0.000,0.803",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.425,0.281,1.472,0.017,-0.684,0.022,0.729"
            ]
        },
        {
            "time": 0.8679999709129334,
            "data": [
                "prisoner,4.621,0.000,1.937,0.000,0.607,0.000,0.795",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.441,0.281,1.468,0.017,-0.660,0.021,0.751"
            ]
        },
        {
            "time": 0.8849999904632568,
            "data": [
                "prisoner,4.637,0.000,1.937,0.000,0.621,0.000,0.784",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.462,0.282,1.462,0.017,-0.628,0.019,0.778"
            ]
        },
        {
            "time": 0.9010000228881836,
            "data": [
                "prisoner,4.652,0.000,1.937,0.000,0.633,0.000,0.774",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.479,0.282,1.458,0.017,-0.601,0.018,0.799"
            ]
        },
        {
            "time": 0.9179999828338623,
            "data": [
                "prisoner,4.666,0.000,1.937,0.000,0.645,0.000,0.764",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.494,0.282,1.454,0.017,-0.576,0.017,0.817"
            ]
        },
        {
            "time": 0.9369999766349793,
            "data": [
                "prisoner,4.680,0.000,1.937,0.000,0.656,0.000,0.755",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.507,0.283,1.451,0.017,-0.554,0.016,0.832"
            ]
        },
        {
            "time": 0.9480000138282776,
            "data": [
                "prisoner,4.696,0.000,1.937,0.000,0.669,0.000,0.743",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.520,0.283,1.447,0.017,-0.531,0.015,0.847"
            ]
        },
        {
            "time": 0.9629999995231628,
            "data": [
                "prisoner,4.706,0.000,1.937,0.000,0.676,0.000,0.737",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.527,0.283,1.446,0.017,-0.520,0.015,0.854"
            ]
        },
        {
            "time": 0.9789999723434448,
            "data": [
                "prisoner,4.717,0.000,1.937,0.000,0.685,0.000,0.728",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.533,0.283,1.444,0.017,-0.509,0.015,0.861"
            ]
        },
        {
            "time": 0.9950000047683716,
            "data": [
                "prisoner,4.729,0.000,1.937,0.000,0.695,0.000,0.719",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.538,0.283,1.443,0.017,-0.500,0.014,0.866"
            ]
        },
        {
            "time": 1.0089999437332154,
            "data": [
                "prisoner,4.741,0.000,1.937,0.000,0.704,0.000,0.710",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.027999997138977,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.711,0.000,0.704",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.0390000343322755,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.717,0.000,0.697",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.0509999990463257,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.721,0.000,0.693",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.0670000314712525,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.726,0.000,0.688",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.0839999914169312,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.731,0.000,0.682",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.0989999771118165,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.737,0.000,0.675",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.1139999628067017,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.743,0.000,0.670",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.128999948501587,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.748,0.000,0.664",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.1449999809265137,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.753,0.000,0.658",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.1549999713897706,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.759,0.000,0.651",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.1710000038146973,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.762,0.000,0.647",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.184999942779541,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.768,0.000,0.641",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.2000000476837159,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.772,0.000,0.635",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.2170000076293946,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.777,0.000,0.629",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.2319999933242798,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.783,0.000,0.622",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.2450000047683716,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.788,0.000,0.616",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.2580000162124634,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.792,0.000,0.611",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.2760000228881837,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.796,0.000,0.605",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.2910000085830689,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.801,0.000,0.598",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.305999994277954,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.806,0.000,0.592",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.3200000524520875,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.811,0.000,0.585",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.3359999656677247,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.815,0.000,0.579",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.3480000495910645,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.820,0.000,0.572",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.3609999418258668,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.823,0.000,0.567",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.3769999742507935,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.827,0.000,0.562",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.3940000534057618,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.832,0.000,0.555",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.409000039100647,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.837,0.000,0.547",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.4229999780654908,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.841,0.000,0.541",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.437000036239624,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.845,0.000,0.534",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.4509999752044678,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.849,0.000,0.528",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.465999960899353,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.853,0.000,0.522",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.4809999465942383,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.857,0.000,0.515",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.4950000047683716,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.861,0.000,0.509",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.5119999647140504,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.865,0.000,0.502",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.527999997138977,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.869,0.000,0.494",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.5440000295639039,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.873,0.000,0.487",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.5549999475479127,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.877,0.000,0.480",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.5679999589920045,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.880,0.000,0.475",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.5829999446868897,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.883,0.000,0.469",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.600000023841858,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.887,0.000,0.462",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.6160000562667847,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.891,0.000,0.454",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.6299999952316285,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.895,0.000,0.447",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.6440000534057618,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.898,0.000,0.440",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.6579999923706055,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.901,0.000,0.433",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.6710000038146973,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.904,0.000,0.427",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.687999963760376,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.907,0.000,0.420",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.7020000219345093,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.911,0.000,0.412",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.718999981880188,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.914,0.000,0.406",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.7330000400543213,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.918,0.000,0.398",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.7480000257492066,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.920,0.000,0.391",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.7630000114440919,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.923,0.000,0.384",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.774999976158142,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.927,0.000,0.376",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.7920000553131104,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.929,0.000,0.371",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.8049999475479127,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.932,0.000,0.362",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.8229999542236329,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.935,0.000,0.356",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.8380000591278077,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.938,0.000,0.347",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.8550000190734864,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.941,0.000,0.340",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.8650000095367432,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.943,0.000,0.331",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.878000020980835,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.945,0.000,0.326",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.8940000534057618,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.948,0.000,0.320",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.909000039100647,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.950,0.000,0.312",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.9240000247955323,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.953,0.000,0.304",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.940000057220459,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.955,0.000,0.297",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.9550000429153443,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.957,0.000,0.289",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.968999981880188,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.960,0.000,0.282",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.9819999933242798,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.962,0.000,0.275",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 1.9980000257492066,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.963,0.000,0.268",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 2.0139999389648439,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.966,0.000,0.260",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.540,0.283,1.442,0.017,-0.496,0.014,0.868"
            ]
        },
        {
            "time": 2.0280001163482668,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.968,0.000,0.252",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.542,0.284,1.442,0.017,-0.497,0.014,0.868"
            ]
        },
        {
            "time": 2.0429999828338625,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.970,0.000,0.244",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.548,0.284,1.440,0.017,-0.498,0.014,0.867"
            ]
        },
        {
            "time": 2.056999921798706,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.971,0.000,0.237",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.558,0.285,1.437,0.017,-0.501,0.014,0.865"
            ]
        },
        {
            "time": 2.072000026702881,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.973,0.000,0.230",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.571,0.286,1.434,0.016,-0.504,0.014,0.863"
            ]
        },
        {
            "time": 2.0859999656677248,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.975,0.000,0.222",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.587,0.287,1.429,0.016,-0.508,0.014,0.861"
            ]
        },
        {
            "time": 2.1019999980926515,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.977,0.000,0.215",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.607,0.288,1.424,0.016,-0.513,0.014,0.858"
            ]
        },
        {
            "time": 2.117000102996826,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.978,0.000,0.207",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.631,0.290,1.417,0.016,-0.519,0.014,0.854"
            ]
        },
        {
            "time": 2.13100004196167,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.980,0.000,0.199",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.658,0.292,1.410,0.015,-0.526,0.014,0.850"
            ]
        },
        {
            "time": 2.1480000019073488,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.981,0.000,0.192",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.684,0.294,1.402,0.015,-0.533,0.014,0.846"
            ]
        },
        {
            "time": 2.1610000133514406,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.983,0.000,0.183",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.718,0.296,1.393,0.015,-0.541,0.014,0.841"
            ]
        },
        {
            "time": 2.180000066757202,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.984,0.000,0.176",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.748,0.299,1.385,0.014,-0.549,0.014,0.836"
            ]
        },
        {
            "time": 2.190999984741211,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.986,0.000,0.167",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.789,0.302,1.374,0.014,-0.559,0.014,0.829"
            ]
        },
        {
            "time": 2.2039999961853029,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.987,0.000,0.161",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.815,0.304,1.367,0.014,-0.566,0.014,0.824"
            ]
        },
        {
            "time": 2.2219998836517336,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.988,0.000,0.154",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.848,0.306,1.357,0.013,-0.574,0.014,0.819"
            ]
        },
        {
            "time": 2.23799991607666,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.989,0.000,0.145",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.892,0.309,1.345,0.013,-0.585,0.014,0.811"
            ]
        },
        {
            "time": 2.253000020980835,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.991,0.000,0.137",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.932,0.312,1.334,0.012,-0.594,0.014,0.804"
            ]
        },
        {
            "time": 2.2690000534057619,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.992,0.000,0.129",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.970,0.315,1.324,0.012,-0.603,0.014,0.797"
            ]
        },
        {
            "time": 2.2869999408721926,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.993,0.000,0.121",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.009,0.318,1.313,0.012,-0.613,0.014,0.790"
            ]
        },
        {
            "time": 2.2980000972747804,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.994,0.000,0.111",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.056,0.321,1.300,0.011,-0.623,0.014,0.782"
            ]
        },
        {
            "time": 2.312999963760376,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.994,0.000,0.106",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.083,0.323,1.293,0.011,-0.630,0.014,0.777"
            ]
        },
        {
            "time": 2.3310000896453859,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.995,0.000,0.098",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.119,0.326,1.283,0.010,-0.638,0.014,0.770"
            ]
        },
        {
            "time": 2.3469998836517336,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.996,0.000,0.088",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.160,0.329,1.271,0.010,-0.648,0.014,0.762"
            ]
        },
        {
            "time": 2.364000082015991,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.997,0.000,0.080",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.196,0.331,1.261,0.010,-0.656,0.013,0.755"
            ]
        },
        {
            "time": 2.378000020980835,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.997,0.000,0.071",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.231,0.334,1.252,0.009,-0.663,0.013,0.748"
            ]
        },
        {
            "time": 2.3929998874664308,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.998,0.000,0.064",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.259,0.336,1.244,0.009,-0.670,0.013,0.742"
            ]
        },
        {
            "time": 2.4089999198913576,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.998,0.000,0.056",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.284,0.338,1.237,0.009,-0.675,0.013,0.737"
            ]
        },
        {
            "time": 2.4260001182556154,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.999,0.000,0.048",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.311,0.340,1.230,0.008,-0.681,0.013,0.732"
            ]
        },
        {
            "time": 2.441999912261963,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,0.999,0.000,0.039",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.334,0.342,1.223,0.008,-0.686,0.013,0.727"
            ]
        },
        {
            "time": 2.4570000171661379,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,1.000,0.000,0.030",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.353,0.343,1.218,0.008,-0.690,0.013,0.723"
            ]
        },
        {
            "time": 2.4730000495910646,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,1.000,0.000,0.023",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.367,0.344,1.214,0.008,-0.693,0.013,0.720"
            ]
        },
        {
            "time": 2.492000102996826,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,1.000,0.000,0.014",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.377,0.345,1.212,0.008,-0.696,0.013,0.718"
            ]
        },
        {
            "time": 2.505000114440918,
            "data": [
                "prisoner,4.744,0.000,1.937,0.000,1.000,0.000,0.004",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.384,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.5199999809265138,
            "data": [
                "prisoner,4.744,0.000,1.930,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.5360000133514406,
            "data": [
                "prisoner,4.744,0.000,1.912,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.552999973297119,
            "data": [
                "prisoner,4.744,0.000,1.891,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.565999984741211,
            "data": [
                "prisoner,4.744,0.000,1.869,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.5840001106262209,
            "data": [
                "prisoner,4.744,0.000,1.852,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.5999999046325685,
            "data": [
                "prisoner,4.744,0.000,1.830,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.618000030517578,
            "data": [
                "prisoner,4.744,0.000,1.809,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.628999948501587,
            "data": [
                "prisoner,4.744,0.000,1.787,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.6470000743865969,
            "data": [
                "prisoner,4.744,0.000,1.773,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.6610000133514406,
            "data": [
                "prisoner,4.744,0.000,1.749,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.680000066757202,
            "data": [
                "prisoner,4.744,0.000,1.731,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.696000099182129,
            "data": [
                "prisoner,4.744,0.000,1.708,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.7139999866485597,
            "data": [
                "prisoner,4.744,0.000,1.687,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.7290000915527345,
            "data": [
                "prisoner,4.744,0.000,1.664,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.740000009536743,
            "data": [
                "prisoner,4.744,0.000,1.644,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.75600004196167,
            "data": [
                "prisoner,4.744,0.000,1.631,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.7739999294281008,
            "data": [
                "prisoner,4.744,0.000,1.611,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.7880001068115236,
            "data": [
                "prisoner,4.744,0.000,1.587,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.805000066757202,
            "data": [
                "prisoner,4.744,0.000,1.569,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.821000099182129,
            "data": [
                "prisoner,4.744,0.000,1.548,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.8380000591278078,
            "data": [
                "prisoner,4.744,0.000,1.528,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.8489999771118166,
            "data": [
                "prisoner,4.744,0.000,1.506,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.867000102996826,
            "data": [
                "prisoner,4.744,0.000,1.491,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.882999897003174,
            "data": [
                "prisoner,4.744,0.000,1.468,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.9000000953674318,
            "data": [
                "prisoner,4.744,0.000,1.448,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.9149999618530275,
            "data": [
                "prisoner,4.744,0.000,1.427,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.934000015258789,
            "data": [
                "prisoner,4.744,0.000,1.408,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.947000026702881,
            "data": [
                "prisoner,4.744,0.000,1.384,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.9590001106262209,
            "data": [
                "prisoner,4.744,0.000,1.366,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.9769999980926515,
            "data": [
                "prisoner,4.744,0.000,1.351,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 2.992000102996826,
            "data": [
                "prisoner,4.744,0.000,1.328,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.007999897003174,
            "data": [
                "prisoner,4.744,0.000,1.310,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.0250000953674318,
            "data": [
                "prisoner,4.744,0.000,1.300,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.0409998893737795,
            "data": [
                "prisoner,4.744,0.000,1.303,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.056999921798706,
            "data": [
                "prisoner,4.744,0.000,1.305,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.069999933242798,
            "data": [
                "prisoner,4.744,0.000,1.307,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.0869998931884767,
            "data": [
                "prisoner,4.744,0.000,1.309,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.1019999980926515,
            "data": [
                "prisoner,4.744,0.000,1.311,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.11899995803833,
            "data": [
                "prisoner,4.744,0.000,1.314,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.135999917984009,
            "data": [
                "prisoner,4.744,0.000,1.316,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.1519999504089357,
            "data": [
                "prisoner,4.744,0.000,1.318,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.1670000553131105,
            "data": [
                "prisoner,4.744,0.000,1.321,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.181999921798706,
            "data": [
                "prisoner,4.744,0.000,1.323,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.2009999752044679,
            "data": [
                "prisoner,4.744,0.000,1.325,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.2290000915527345,
            "data": [
                "prisoner,4.744,0.000,1.328,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.253999948501587,
            "data": [
                "prisoner,4.744,0.000,1.331,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.2780001163482668,
            "data": [
                "prisoner,4.744,0.000,1.335,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.2980000972747804,
            "data": [
                "prisoner,4.744,0.000,1.338,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.315999984741211,
            "data": [
                "prisoner,4.744,0.000,1.341,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.3389999866485597,
            "data": [
                "prisoner,4.744,0.000,1.344,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.361999988555908,
            "data": [
                "prisoner,4.744,0.000,1.347,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.384999990463257,
            "data": [
                "prisoner,4.744,0.000,1.350,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.4049999713897707,
            "data": [
                "prisoner,4.744,0.000,1.354,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.421999931335449,
            "data": [
                "prisoner,4.744,0.000,1.357,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.440999984741211,
            "data": [
                "prisoner,4.744,0.000,1.359,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.4619998931884767,
            "data": [
                "prisoner,4.744,0.000,1.362,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.4820001125335695,
            "data": [
                "prisoner,4.744,0.000,1.365,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.5,
            "data": [
                "prisoner,4.744,0.000,1.367,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.5169999599456789,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,1.000,0.000,0.000",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.5339999198913576,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,1.000,0.000,-0.013",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.5510001182556154,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,1.000,0.000,-0.027",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.569999933242798,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.999,0.000,-0.040",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.5880000591278078,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.998,0.000,-0.055",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.6040000915527345,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.998,0.000,-0.069",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.619999885559082,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.997,0.000,-0.082",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.640000104904175,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.996,0.000,-0.094",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.6559998989105226,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.994,0.000,-0.110",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.6740000247955324,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.993,0.000,-0.122",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.693000078201294,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.991,0.000,-0.137",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.7090001106262209,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.989,0.000,-0.151",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.7260000705718996,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.987,0.000,-0.163",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.742000102996826,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.984,0.000,-0.177",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.759999990463257,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.982,0.000,-0.189",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.7790000438690187,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.979,0.000,-0.203",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.7960000038146974,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.976,0.000,-0.217",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.812000036239624,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.973,0.000,-0.231",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.8299999237060549,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.970,0.000,-0.243",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.8459999561309816,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.967,0.000,-0.256",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.865000009536743,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.963,0.000,-0.268",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.882999897003174,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.959,0.000,-0.283",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.9000000953674318,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.955,0.000,-0.296",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.9170000553131105,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.951,0.000,-0.309",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.934999942779541,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.947,0.000,-0.322",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.9519999027252199,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.942,0.000,-0.335",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.9679999351501467,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.938,0.000,-0.348",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 3.986999988555908,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.933,0.000,-0.359",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.064000129699707,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.928,0.000,-0.374",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.0920000076293949,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.903,0.000,-0.429",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.105000019073486,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.894,0.000,-0.448",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.126999855041504,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.889,0.000,-0.458",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.13700008392334,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.881,0.000,-0.473",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.150000095367432,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.878,0.000,-0.479",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.163000106811523,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.873,0.000,-0.488",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.176000118255615,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.867,0.000,-0.498",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.191999912261963,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.862,0.000,-0.506",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.210000038146973,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.856,0.000,-0.517",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.229000091552734,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.849,0.000,-0.529",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.244999885559082,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.841,0.000,-0.542",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.257999897003174,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.834,0.000,-0.552",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.27400016784668,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.828,0.000,-0.560",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.290999889373779,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.821,0.000,-0.571",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.308000087738037,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.813,0.000,-0.582",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.323999881744385,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.806,0.000,-0.593",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.3420000076293949,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.798,0.000,-0.603",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.35699987411499,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.789,0.000,-0.614",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.370999813079834,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.782,0.000,-0.624",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.38700008392334,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.775,0.000,-0.632",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.4039998054504398,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.767,0.000,-0.642",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.421000003814697,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.758,0.000,-0.652",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.438000202178955,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.750,0.000,-0.662",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.454999923706055,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.741,0.000,-0.672",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.4710001945495609,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.731,0.000,-0.682",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.484000205993652,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.723,0.000,-0.691",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.5,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.716,0.000,-0.698",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.519000053405762,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.671,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.674,0.000,2.003,0.000,-0.844,0.000,0.537",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.385,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.546999931335449,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.670,0.000,1.111,0.000,-0.571,0.000,0.821",
                "police4,5.673,0.000,2.003,0.000,-0.844,0.000,0.536",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.384,0.345,1.210,0.008,-0.697,0.013,0.717"
            ]
        },
        {
            "time": 4.572999954223633,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.666,0.000,1.112,0.000,-0.571,0.000,0.821",
                "police4,5.668,0.000,2.000,0.000,-0.845,0.000,0.535",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.381,0.345,1.214,0.008,-0.698,0.013,0.716"
            ]
        },
        {
            "time": 4.599999904632568,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.659,0.000,1.114,0.000,-0.571,0.000,0.821",
                "police4,5.660,0.000,1.996,0.000,-0.847,0.000,0.532",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.375,0.346,1.220,0.008,-0.700,0.013,0.714"
            ]
        },
        {
            "time": 4.622000217437744,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.649,0.000,1.116,0.000,-0.571,0.000,0.821",
                "police4,5.649,0.000,1.990,0.000,-0.850,0.000,0.527",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.367,0.346,1.228,0.009,-0.702,0.014,0.712"
            ]
        },
        {
            "time": 4.644999980926514,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.639,0.000,1.119,0.000,-0.571,0.000,0.821",
                "police4,5.637,0.000,1.984,0.000,-0.852,0.000,0.523",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.359,0.346,1.236,0.009,-0.704,0.015,0.710"
            ]
        },
        {
            "time": 4.669000148773193,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.626,0.000,1.122,0.000,-0.571,0.000,0.821",
                "police4,5.623,0.000,1.976,0.000,-0.855,0.000,0.518",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.350,0.346,1.247,0.010,-0.707,0.015,0.707"
            ]
        },
        {
            "time": 4.693999767303467,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.611,0.000,1.125,0.000,-0.571,0.000,0.821",
                "police4,5.605,0.000,1.968,0.000,-0.859,0.000,0.511",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.338,0.347,1.259,0.011,-0.710,0.016,0.703"
            ]
        },
        {
            "time": 4.71999979019165,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.594,0.000,1.129,0.000,-0.571,0.000,0.821",
                "police4,5.585,0.000,1.957,0.000,-0.864,0.000,0.504",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.324,0.347,1.273,0.012,-0.714,0.017,0.700"
            ]
        },
        {
            "time": 4.739999771118164,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.574,0.000,1.134,0.000,-0.571,0.000,0.821",
                "police4,5.562,0.000,1.945,0.000,-0.869,0.000,0.495",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.308,0.348,1.290,0.013,-0.719,0.019,0.695"
            ]
        },
        {
            "time": 4.757999897003174,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.556,0.000,1.138,0.000,-0.571,0.000,0.821",
                "police4,5.542,0.000,1.935,0.000,-0.873,0.000,0.488",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.295,0.348,1.304,0.014,-0.722,0.020,0.691"
            ]
        },
        {
            "time": 4.7779998779296879,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.541,0.000,1.142,0.000,-0.571,0.000,0.821",
                "police4,5.525,0.000,1.926,0.000,-0.877,0.000,0.481",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.283,0.349,1.317,0.014,-0.726,0.021,0.688"
            ]
        },
        {
            "time": 4.800000190734863,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.522,0.000,1.147,0.000,-0.571,0.000,0.821",
                "police4,5.503,0.000,1.914,0.000,-0.881,0.000,0.473",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.268,0.349,1.333,0.015,-0.730,0.022,0.683"
            ]
        },
        {
            "time": 4.821000099182129,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.501,0.000,1.152,0.000,-0.571,0.000,0.821",
                "police4,5.479,0.000,1.902,0.000,-0.886,0.000,0.464",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.252,0.350,1.350,0.016,-0.734,0.023,0.678"
            ]
        },
        {
            "time": 4.8379998207092289,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.479,0.000,1.157,0.000,-0.571,0.000,0.821",
                "police4,5.454,0.000,1.889,0.000,-0.891,0.000,0.454",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.235,0.350,1.368,0.017,-0.739,0.025,0.673"
            ]
        },
        {
            "time": 4.853000164031982,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.462,0.000,1.161,0.000,-0.571,0.000,0.821",
                "police4,5.434,0.000,1.879,0.000,-0.895,0.000,0.447",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.221,0.351,1.382,0.018,-0.742,0.026,0.669"
            ]
        },
        {
            "time": 4.873000144958496,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.445,0.000,1.165,0.000,-0.571,0.000,0.821",
                "police4,5.415,0.000,1.869,0.000,-0.898,0.000,0.439",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.208,0.351,1.396,0.019,-0.746,0.027,0.665"
            ]
        },
        {
            "time": 4.89300012588501,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.423,0.000,1.170,0.000,-0.571,0.000,0.821",
                "police4,5.389,0.000,1.856,0.000,-0.903,0.000,0.429",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.191,0.352,1.414,0.020,-0.750,0.028,0.660"
            ]
        },
        {
            "time": 4.908999919891357,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.401,0.000,1.175,0.000,-0.571,0.000,0.821",
                "police4,5.364,0.000,1.843,0.000,-0.908,0.000,0.420",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.174,0.352,1.432,0.021,-0.755,0.030,0.655"
            ]
        },
        {
            "time": 4.932000160217285,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.383,0.000,1.180,0.000,-0.571,0.000,0.821",
                "police4,5.343,0.000,1.832,0.000,-0.911,0.000,0.411",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.159,0.353,1.447,0.021,-0.759,0.031,0.650"
            ]
        },
        {
            "time": 4.945000171661377,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.356,0.000,1.186,0.000,-0.571,0.000,0.821",
                "police4,5.312,0.000,1.816,0.000,-0.917,0.000,0.399",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.138,0.353,1.469,0.023,-0.764,0.033,0.644"
            ]
        },
        {
            "time": 4.960999965667725,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.341,0.000,1.190,0.000,-0.571,0.000,0.821",
                "police4,5.295,0.000,1.807,0.000,-0.920,0.000,0.393",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.127,0.354,1.482,0.023,-0.767,0.034,0.640"
            ]
        },
        {
            "time": 4.978000164031982,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.322,0.000,1.194,0.000,-0.571,0.000,0.821",
                "police4,5.274,0.000,1.796,0.000,-0.923,0.000,0.384",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.112,0.354,1.497,0.024,-0.771,0.035,0.636"
            ]
        },
        {
            "time": 4.998000144958496,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.302,0.000,1.199,0.000,-0.571,0.000,0.821",
                "police4,5.251,0.000,1.784,0.000,-0.927,0.000,0.375",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.096,0.355,1.514,0.025,-0.775,0.037,0.631"
            ]
        },
        {
            "time": 5.014999866485596,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.279,0.000,1.204,0.000,-0.571,0.000,0.821",
                "police4,5.224,0.000,1.771,0.000,-0.931,0.000,0.364",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.078,0.355,1.533,0.026,-0.779,0.038,0.625"
            ]
        },
        {
            "time": 5.0370001792907719,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.259,0.000,1.209,0.000,-0.571,0.000,0.821",
                "police4,5.200,0.000,1.758,0.000,-0.935,0.000,0.355",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.062,0.356,1.550,0.026,-0.783,0.040,0.620"
            ]
        },
        {
            "time": 5.054999828338623,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.233,0.000,1.215,0.000,-0.571,0.000,0.821",
                "police4,5.171,0.000,1.743,0.000,-0.939,0.000,0.343",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.042,0.356,1.571,0.027,-0.788,0.042,0.614"
            ]
        },
        {
            "time": 5.065999984741211,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.212,0.000,1.220,0.000,-0.571,0.000,0.821",
                "police4,5.147,0.000,1.731,0.000,-0.943,0.000,0.333",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.026,0.357,1.588,0.028,-0.792,0.043,0.608"
            ]
        },
        {
            "time": 5.086999893188477,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.198,0.000,1.224,0.000,-0.571,0.000,0.821",
                "police4,5.131,0.000,1.723,0.000,-0.945,0.000,0.327",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,6.015,0.357,1.600,0.028,-0.795,0.044,0.605"
            ]
        },
        {
            "time": 5.105000019073486,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.175,0.000,1.229,0.000,-0.571,0.000,0.821",
                "police4,5.104,0.000,1.709,0.000,-0.949,0.000,0.316",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.996,0.358,1.619,0.029,-0.799,0.046,0.599"
            ]
        },
        {
            "time": 5.138000011444092,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.155,0.000,1.234,0.000,-0.571,0.000,0.821",
                "police4,5.081,0.000,1.697,0.000,-0.952,0.000,0.306",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.981,0.358,1.636,0.030,-0.803,0.048,0.594"
            ]
        },
        {
            "time": 5.140999794006348,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.117,0.000,1.243,0.000,-0.571,0.000,0.821",
                "police4,5.038,0.000,1.674,0.000,-0.958,0.000,0.288",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.951,0.359,1.667,0.031,-0.809,0.050,0.584"
            ]
        },
        {
            "time": 5.158999919891357,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.114,0.000,1.244,0.000,-0.571,0.000,0.821",
                "police4,5.034,0.000,1.673,0.000,-0.958,0.000,0.287",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.949,0.359,1.669,0.031,-0.810,0.051,0.583"
            ]
        },
        {
            "time": 5.176000118255615,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.094,0.000,1.248,0.000,-0.571,0.000,0.821",
                "police4,5.012,0.000,1.661,0.000,-0.961,0.000,0.278",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.934,0.360,1.685,0.032,-0.813,0.052,0.578"
            ]
        },
        {
            "time": 5.195000171661377,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.077,0.000,1.252,0.000,-0.571,0.000,0.821",
                "police4,4.992,0.000,1.651,0.000,-0.963,0.000,0.269",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.920,0.360,1.700,0.032,-0.817,0.053,0.574"
            ]
        },
        {
            "time": 5.211999893188477,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.057,0.000,1.257,0.000,-0.571,0.000,0.821",
                "police4,4.969,0.000,1.639,0.000,-0.966,0.000,0.260",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.904,0.361,1.716,0.033,-0.820,0.055,0.569"
            ]
        },
        {
            "time": 5.230999946594238,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.041,0.000,1.261,0.000,-0.571,0.000,0.821",
                "police4,4.950,0.000,1.629,0.000,-0.968,0.000,0.252",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.892,0.361,1.730,0.033,-0.823,0.056,0.564"
            ]
        },
        {
            "time": 5.249000072479248,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.022,0.000,1.266,0.000,-0.571,0.000,0.821",
                "police4,4.929,0.000,1.618,0.000,-0.970,0.000,0.243",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.877,0.362,1.745,0.034,-0.826,0.058,0.560"
            ]
        },
        {
            "time": 5.267000198364258,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,5.007,0.000,1.269,0.000,-0.571,0.000,0.821",
                "police4,4.911,0.000,1.609,0.000,-0.972,0.000,0.236",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.865,0.362,1.758,0.034,-0.829,0.059,0.555"
            ]
        },
        {
            "time": 5.2829999923706059,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.991,0.000,1.273,0.000,-0.571,0.000,0.821",
                "police4,4.893,0.000,1.600,0.000,-0.974,0.000,0.228",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.853,0.363,1.771,0.035,-0.831,0.060,0.551"
            ]
        },
        {
            "time": 5.301000118255615,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.977,0.000,1.276,0.000,-0.571,0.000,0.821",
                "police4,4.877,0.000,1.592,0.000,-0.975,0.000,0.222",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.842,0.363,1.782,0.035,-0.834,0.061,0.548"
            ]
        },
        {
            "time": 5.318999767303467,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.963,0.000,1.280,0.000,-0.571,0.000,0.821",
                "police4,4.861,0.000,1.583,0.000,-0.977,0.000,0.215",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.831,0.363,1.793,0.035,-0.836,0.062,0.544"
            ]
        },
        {
            "time": 5.3379998207092289,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.950,0.000,1.283,0.000,-0.571,0.000,0.821",
                "police4,4.846,0.000,1.575,0.000,-0.978,0.000,0.208",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.821,0.364,1.804,0.036,-0.838,0.063,0.540"
            ]
        },
        {
            "time": 5.359000205993652,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.937,0.000,1.286,0.000,-0.571,0.000,0.821",
                "police4,4.832,0.000,1.568,0.000,-0.979,0.000,0.202",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.811,0.364,1.815,0.036,-0.840,0.064,0.537"
            ]
        },
        {
            "time": 5.375,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.925,0.000,1.289,0.000,-0.571,0.000,0.821",
                "police4,4.817,0.000,1.560,0.000,-0.981,0.000,0.196",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.801,0.364,1.825,0.036,-0.842,0.065,0.534"
            ]
        },
        {
            "time": 5.388000011444092,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.916,0.000,1.291,0.000,-0.571,0.000,0.821",
                "police4,4.807,0.000,1.555,0.000,-0.981,0.000,0.192",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.794,0.364,1.833,0.036,-0.844,0.066,0.531"
            ]
        },
        {
            "time": 5.406000137329102,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.910,0.000,1.292,0.000,-0.571,0.000,0.821",
                "police4,4.800,0.000,1.551,0.000,-0.982,0.000,0.189",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.789,0.365,1.838,0.037,-0.845,0.066,0.530"
            ]
        },
        {
            "time": 5.423999786376953,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.902,0.000,1.294,0.000,-0.571,0.000,0.821",
                "police4,4.791,0.000,1.547,0.000,-0.983,0.000,0.185",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.783,0.365,1.844,0.037,-0.846,0.067,0.528"
            ]
        },
        {
            "time": 5.442999839782715,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.895,0.000,1.296,0.000,-0.571,0.000,0.821",
                "police4,4.783,0.000,1.543,0.000,-0.983,0.000,0.182",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.778,0.365,1.850,0.037,-0.847,0.068,0.526"
            ]
        },
        {
            "time": 5.4629998207092289,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.889,0.000,1.297,0.000,-0.571,0.000,0.821",
                "police4,4.776,0.000,1.539,0.000,-0.984,0.000,0.179",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.773,0.365,1.855,0.037,-0.848,0.068,0.524"
            ]
        },
        {
            "time": 5.48199987411499,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.885,0.000,1.298,0.000,-0.571,0.000,0.821",
                "police4,4.772,0.000,1.537,0.000,-0.984,0.000,0.177",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.770,0.365,1.858,0.037,-0.849,0.068,0.523"
            ]
        },
        {
            "time": 5.494999885559082,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.883,0.000,1.299,0.000,-0.571,0.000,0.821",
                "police4,4.769,0.000,1.535,0.000,-0.984,0.000,0.176",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.768,0.365,1.860,0.037,-0.849,0.069,0.522"
            ]
        },
        {
            "time": 5.513999938964844,
            "data": [
                "prisoner,4.744,0.000,1.370,0.000,0.707,0.000,-0.707",
                "police3,4.882,0.000,1.299,0.000,-0.571,0.000,0.821",
                "police4,4.768,0.000,1.535,0.000,-0.984,0.000,0.175",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.768,0.365,1.860,0.037,-0.849,0.069,0.522"
            ]
        }
    ]
};
